// extracted by mini-css-extract-plugin
module.exports = {"AccountCard":"Accounts_AccountCard__oc-Qy","icon":"Accounts_icon__3IHRt"};